import React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  fillOpacity: ".3",
  d: "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
}), 'SignalWifi0BarOutlined');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/icons/esm/SignalWifi0BarOutlined.js
// module id = 5753
// module chunks = 13